import { IPromise } from 'angular';
import { IDjangoFontStyle } from '../classes';
import { FontListParams, FontRepository } from './FontRepository';
import { IPagedResult } from '../../tn.django/django-client.service/djangoClient';

export class FontStyleRepository extends FontRepository {
    protected baseUri = '/api/1/styles/';
    static $inject = ['djangoClient'];

    protected _filtersToParams(filters: FontListParams): URLSearchParams {
        const params = super._filtersToParams(filters);
        if (filters.family) {
            filters.family.forEach((family) =>
                params.set('family', family.toString())
            );
        }
        return params;
    }

    public get(id: number): IPromise<IDjangoFontStyle> {
        return super.get(id) as IPromise<IDjangoFontStyle>;
    }

    // https://api.typenetwork.com/api/1/families/recommended_size=700&recommended_size=800
    public list(
        filters: FontListParams
    ): IPromise<IPagedResult<IDjangoFontStyle>> {
        return super.list(filters) as IPromise<IPagedResult<IDjangoFontStyle>>;
    }
}

export class FontStylePublicRepository extends FontStyleRepository {
    protected _filtersToParams(filters: FontListParams): URLSearchParams {
        const params = super._filtersToParams(filters);
        const id = filters.id?.join(',');
        if (id) params.set('id', id);
        return params;
    }
    protected baseUri = '/api/1/public/styles/';
}
